import * as React from 'react';
import { match } from 'react-router';
import { Button } from 'reactstrap';
import './viewButtons.css';
import { ICase } from 'src/share/types/case/case';
import { ETLHelper } from 'src/share/components/ETLHelper/ETLHelper';
import { CasesService } from 'src/share/services/cases';
import { toastr } from 'react-redux-toastr';
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';

export interface IViewButtonsProps {
  history: any;
  caseData: ICase;
  loading: boolean;
  match: match<{ caseId: string }>
  matchesRedirect?: boolean
  permissionCase: boolean,
  isAnETLCase: boolean
};

interface IViewButtonsState {
  loading: boolean;
  isDeleteModalOpen: boolean;
}

export default class ViewButtons extends React.Component<IViewButtonsProps, IViewButtonsState> {
  constructor(props: IViewButtonsProps) {
    super(props);
    this.state = { loading: false, isDeleteModalOpen: false };
  }

  public redirectToClose = () => {
    this.props.history.push(`/close/${this.props.match.params.caseId}`)
  }
  public redirectToEdit = () => {
    this.props.history.push(`/case/edit/${this.props.match.params.caseId}`)
  }
  public redirectToCreateAlert = () => {
    this.props.history.push(`/alerts/add/${this.props.match.params.caseId}`)
  }
  public redirectToManualSearch = () => {
    this.props.history.replace('/rekognition/matches')
  }
  public toggleDeleteModal = () => {
    this.setState(s => ({ isDeleteModalOpen: !s.isDeleteModalOpen }));
  }
  public reopenCase = async () => {
    this.setState({ loading: true });
    try {
      const { caseData } = this.props;
      const reopened = { ...caseData, status: 'open', closedDate: undefined };
      await CasesService.update(caseData, reopened);
      toastr.success('Reopen Case', 'The case has been reopened');
      this.props.history.push(`/case/edit/${this.props.match.params.caseId}`);
    } catch (error) {
      toastr.error('Reopen Case', 'There was a problem reopening the case');
      this.setState({ loading: false });
    }
  }
  public deleteCase = async () => {
    this.setState({ loading: true });
    try {
      await CasesService.delete(this.props.match.params.caseId);
      toastr.success('Delete Case', 'The case has been deleted correctly');
      this.props.history.push('/');
    } catch (error) {
      toastr.error('Delete Case', 'There was a problem deleting the case');
      this.setState({ loading: false });
    }
  }

  public render() {
    const { loading: propsLoading, caseData } = this.props;
    const { loading: stateLoading, isDeleteModalOpen } = this.state;
    const loading = propsLoading || stateLoading;
    const isClosed = caseData.status === 'closed';
    const canAct = this.props.permissionCase && !this.props.isAnETLCase;

    return (
      <div>
        <ETLHelper etl={this.props.caseData.etl} />
        {
          !loading && !isClosed && (
            <div className="buttons">
              {
                canAct &&
                <>
                  {
                    !this.props.isAnETLCase &&
                    <Button className="btn" onClick={this.redirectToClose}>
                      Close case
                    </Button>
                  }
                  <Button className="btn" onClick={this.redirectToEdit}>
                    Edit Case
                  </Button>
                </>
              }
              <Button className="btn btn-blue btn-secondary" onClick={this.props.matchesRedirect ? this.redirectToManualSearch : this.redirectToCreateAlert}>
                {this.props.matchesRedirect ? 'Matches search' : 'Create an Alert'}
              </Button>
            </div>
          )
        }
        {
          !loading && isClosed && canAct && (
            <div className="buttons">
              <Button className="btn" onClick={this.reopenCase}>
                Reopen Case
              </Button>
              <Button className="btn btn-outline btn-grey-fill" onClick={this.toggleDeleteModal}>
                Delete Case
              </Button>
            </div>
          )
        }
        <ConfirmationModal
          isOpen={isDeleteModalOpen}
          toggle={this.toggleDeleteModal}
          title={`Delete Case #${this.props.match.params.caseId}`}
          description="Are you sure you want to delete this case?"
          onContinue={() => {
            this.toggleDeleteModal();
            this.deleteCase();
          }}
        />
      </div>
    )
  }
}
